import {
  Component,
  HostBinding,
  Input,
  OnInit,
  OnChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { NavItem } from "./nav-item";
import { Router, RouterModule } from "@angular/router";
import { NavService } from "@assoanalytics/app/core/services/nav.service";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { TablerIconsModule } from "angular-tabler-icons";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MaterialModule } from "@assoanalytics/app/material.module";
import { CommonModule } from "@angular/common";
import { CoreService } from "@assoanalytics/app/core/services/core.service";
import { SidebarNavItemStatusDirective } from "@assoanalytics/app/shared/directives/sidebar-active-status.directive";

@Component({
  selector: "app-nav-item",
  imports: [
    TablerIconsModule,
    TranslateModule,
    MaterialModule,
    CommonModule,
    SidebarNavItemStatusDirective,
    RouterModule,
  ],
  templateUrl: "./nav-item.component.html",
  styleUrls: ["./nav-item.component.scss"],
  animations: [
    trigger("indicatorRotate", [
      state("collapsed", style({ transform: "rotate(0deg)" })),
      state("expanded", style({ transform: "rotate(180deg)" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4,0.0,0.2,1)"),
      ),
    ]),
    trigger("expandCollapse", [
      state(
        "collapsed",
        style({ height: "0px", overflow: "hidden", opacity: 0 }),
      ),
      state("expanded", style({ height: "*", overflow: "hidden", opacity: 1 })),
      transition("collapsed <=> expanded", [animate("150ms ease-in-out")]),
    ]),
  ],
})
export class AppNavItemComponent {
  @Output() toggleMobileLink: any = new EventEmitter<void>();
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() expanded: boolean = false;
  @Output() expandEmitter: EventEmitter<void> = new EventEmitter();

  disabled: any = false;
  twoLines: any = false;
  @HostBinding("attr.aria-expanded") ariaExpanded = this.expanded;
  @Input() item: NavItem | any;
  @Input() depth: any;

  options = this.settings.getOptions();

  constructor(
    public navService: NavService,
    public router: Router,
    private translateService: TranslateService,
    private settings: CoreService,
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  getTranslatedItem(key: any) {
    return this.translateService.instant(`MENU.${key}`).startsWith("MENU")
      ? key
      : this.translateService.instant(`MENU.${key}`);
  }

  onItemSelected(event: MouseEvent, item: NavItem) {
    // Solo click sinistro senza modificatori → SPA
    if (
      event.button === 0 && // tasto sinistro
      !event.ctrlKey &&
      !event.metaKey &&
      !event.shiftKey &&
      !event.altKey
    ) {
      event.preventDefault();
      if (!item.children || !item.children.length) {
        this.router.navigate([item.route]);

        // chiusura sidebar se nav item non ha discendenti
        // handling per mobile
        if (window.innerWidth <= 480) {
          this.notify.emit();
        }

        // handling per tablet - collapse in minisidebar
        if (window.innerWidth > 480 && window.innerWidth <= 1024) {
          this.options.sidenavCollapsed = true;
          setTimeout(() => this.settings.setOptions(this.options), 400);
        }
      }

      if (item.children && item.children.length) {
        this.expandEmitter.emit();
      }

      setTimeout(() => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 200);
    }
    // Altrimenti lascia il comportamento browser (nuova scheda, tasto destro, ecc.)
  }

  openExternalLink(url: string, blank: boolean = false) {
    window.open(url, blank ? "_blank" : "_self");
  }
}
